import { FEATURE_FLAGS } from '@/constants';
import { useFeatureFlag } from '@/hooks/use-feature-flag';

/**
 * Route-level gate for deciding whether to render the Imply readings lane.
 *
 * Uses LaunchDarkly via `useFeatureFlag`; defaults to ClickHouse lane when the SDK is unavailable (`false` in FEATURE_FLAG_DEFAULTS).
 */
export const useImplyReadingsEnabled = (): boolean => {
  return useFeatureFlag(FEATURE_FLAGS.IMPLY_READINGS);
};
